module.exports = __webpack_public_path__ + "img/powered_by.b11ebe2c.svg";